
import React from 'react';
import PropTypes from 'prop-types';

const CloseButton = props => {
  const { onCloseTool, closeButtonText } = props;
  return (
    <button
      className="close-btn outline"
      onClick={onCloseTool}
      aria-label={closeButtonText}
      tabIndex="0"
    >
      <svg viewBox="0 0 36 36" focusable="false">
        <title>{closeButtonText}</title>
        <circle cx="18" cy="18" r="18" />
        <path
          d="M19.51 18l5.69-5.71a1.06 1.06 0 1 0-1.51-1.49L18 16.49l-5.69-5.69a1.06 1.06 0 1 0-1.51
          1.49L16.49 18l-5.69 5.69a1.07 1.07 0 1 0 1.51 1.51L18 19.51l5.69 5.69a1.07 1.07 0 1 0 1.51-1.51z"
        />
      </svg>
    </button>
  );
};

if (process.env.NODE_ENV !== 'production') {
  CloseButton.propTypes = {
    closeButtonText: PropTypes.string.isRequired,
    onCloseTool: PropTypes.func.isRequired,
  };
}

export default CloseButton;
